import { MenuGroup, MenuItem } from '../enum/menu.enums';
import { PortalUserDto, PortalUserRole } from '../../domain/admin/models/portalUserDto';

export function getUnauthorizedRolesByItems(item: MenuItem): any {
    const unAuthorizedRoles: PortalUserRole[] = [];
    switch (item) {
        case MenuItem.DashCustomer:
            unAuthorizedRoles.push(PortalUserRole.Vendor);
            break;
        case MenuItem.CaseAdd:
        case MenuItem.CaseEdit:
            unAuthorizedRoles.push(PortalUserRole.Vendor);
            break;
        case MenuItem.Reports:
            unAuthorizedRoles.push(PortalUserRole.CanConfirmCase);
            unAuthorizedRoles.push(PortalUserRole.CanScheduleCase);
            break;
        case MenuItem.Faq:
            unAuthorizedRoles.push(PortalUserRole.Vendor);
            break;
    }

    return unAuthorizedRoles;
}

//hide menu based on user roles
export function setNavGroupsToHide(user: PortalUserDto): any {
    const navItemsToHide: MenuItem[] = [];
    //TODO: convert to show only menu logic, get menu items from database

    if ((user.canScheduleCase == null || user.canScheduleCase == false) && (user.canConfirmCase == null || user.canConfirmCase == false)) {
        navItemsToHide.push(MenuItem.DashCustomer);
        navItemsToHide.push(MenuItem.Faq);
    }

    if (user.canScheduleCase == null || user.canScheduleCase == false) {
        navItemsToHide.push(MenuItem.CaseAdd);
    }

    if (!user.vendor) {
        navItemsToHide.push(MenuItem.Reports);
    }

    return { menuItems: navItemsToHide };
}
